export const GROUP_NAME = 'datetime-picker'

export enum PickerVariants {
  SideBySide = 'side-by-side',
  Tabs = 'tabs',
}

export const DEFAULT_PICKER_VARIANT = PickerVariants.Tabs

export enum TimeVariants {
  Clock = 'clock',
}

export const DEFAULT_TIME_VARIANT = TimeVariants.Clock

export enum Orientations {
  Horizontal = 'horizontal',
  Responsive = 'responsive',
  Vertical = 'vertical',
}

export const DEFAULT_ORIENTATION = Orientations.Responsive
export const DEFAULT_DESKTOP_ORIENTATION = Orientations.Horizontal
export const DEFAULT_MOBILE_ORIENTATION = Orientations.Vertical
